// extracted by mini-css-extract-plugin
export var flexItem = "phaseOne-module--flexItem--d7qIB";
export var textContainer = "phaseOne-module--textContainer--5oMo8";